import { createSelector } from '@reduxjs/toolkit';
export const externalJobsReducer = createSelector([(state) => state.externalJobs], (externalJobs) => externalJobs);
export const externalJobsSelector = createSelector(externalJobsReducer, (reducer) => reducer.data);
